export default __webpack_public_path__ + "static/media/main-logo.3353259d.jpg";